import { request } from "services/request";

const resource = "api/CargorunIndexes";

export type CargorunIndexPeriodType =
    | "LastThreeMonths"
    | "LastSixMonths"
    | "FromStartOfTheYear"
    | "LastYear"
    | "LastThreeYears"
    | "AllTime";

export type CargorunIndexTrailerFamilyType = "Tent" | "Refrigerator";

export interface CargorunIndexWeek {
    week: string;
    index: number;
    median: number;
    mean: number;
    count: number;
}

export interface CargorunIndexForPeriod {
    weekDifferences?: number | null;
    monthDifferences?: number | null;
    yearDifferences?: number | null;
    index: number;
    median: number;
    mean: number;
    count: number;
}

export interface CargorunIndexesResponse {
    lastSevenDaysIndex: CargorunIndexForPeriod | null;
    weeks?: CargorunIndexWeek[];
    weekDifferences?: number | null;
    monthDifferences?: number | null;
    yearDifferences?: number | null;
}

export interface CargorunAverageRatesByDestinationWeek {
    week: string;
    count: number;
    min: number;
    percentile25: number;
    median: number;
    percentile75: number;
    max: number;
    mean: number;
}

export interface CargorunAverageRatesByDestinationForPeriod {
    weekDifferences?: number | null;
    monthDifferences?: number | null;
    yearDifferences?: number | null;
    count: number;
    min: number;
    percentile25: number;
    median: number;
    percentile75: number;
    max: number;
    mean: number;
}

export interface CargorunAverageRatesByDestinationResponse {
    lastSevenDaysRate: CargorunAverageRatesByDestinationForPeriod | null;
    weeks?: CargorunAverageRatesByDestinationWeek[];
    weekDifferences?: number | null;
    monthDifferences?: number | null;
    yearDifferences?: number | null;
    distance?: number | null;
}

interface GetCargorunIndexesParams {
    periodType: CargorunIndexPeriodType;
    trailerFamilyType: CargorunIndexTrailerFamilyType | null;
    isVatTop: boolean;
}

interface GetAverageRatesByDestinationParams {
    fromId: number;
    toId: number;
    periodType: CargorunIndexPeriodType;
    trailerFamilyType: CargorunIndexTrailerFamilyType;
    isVatTop: boolean;
}

export function getCargorunIndexes(
    params: GetCargorunIndexesParams,
): Promise<CargorunIndexesResponse | false | undefined> {
    const query = new URLSearchParams({
        periodType: params.periodType,
        isVatTop: String(params.isVatTop),
    });

    if (params.trailerFamilyType) {
        query.set("trailerFamilyType", params.trailerFamilyType);
    }

    return request(`${resource}/GetIndexes?${query.toString()}`, { method: "GET" });
}

export function getAverageRatesByDestination(
    params: GetAverageRatesByDestinationParams,
): Promise<CargorunAverageRatesByDestinationResponse | false | undefined> {
    const query = new URLSearchParams({
        fromId: String(params.fromId),
        toId: String(params.toId),
        periodType: params.periodType,
        trailerFamilyType: params.trailerFamilyType,
        isVatTop: String(params.isVatTop),
    });

    return request(`${resource}/GetAverageRatesByDestination?${query.toString()}`, { method: "GET" });
}
